/**
 * Runtime configuration loaded from public/config.js (window.__APP_CONFIG__).
 * .env / REACT_APP_* are not used — edit public/config.js per environment.
 */
export interface AppConfig {
  API_BASE_URL?: string;
  BASE_PATH?: string;
  RECAPTCHA_SITE_KEY?: string;
  API_TIMEOUT?: number | string;
  IDS_URL?: string;
  QRCARD_URL?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const hasValue = (value: unknown): boolean =>
  value !== undefined && value !== null && String(value).trim() !== "";

export const getRuntimeConfig = <T = string>(
  key: keyof AppConfig,
  defaultValue?: T
): T => {
  if (typeof window !== "undefined" && window.__APP_CONFIG__) {
    const runtimeValue = window.__APP_CONFIG__[key];
    if (hasValue(runtimeValue)) {
      return runtimeValue as T;
    }
  }

  if (defaultValue !== undefined) {
    return defaultValue;
  }

  if (typeof window === "undefined") {
    return "" as T;
  }

  throw new Error(
    `Missing required configuration "${String(key)}". Set it in public/config.js.`
  );
};
